import { CircularProgress } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";

import { AuthContext } from "../../../context/auth-context";
import { DiscoveryContext } from "../discovery-context";
import EmptyView from "./../../../Component/EmptyView/EmptyView";
import ErrorMessage from "./../../../Component/ErrorMessage/ErrorMessage";
import ErrorView from "./../../../Component/ErrorView/ErrorView";
import MUIButton from "./../../../Component/UI/MUIButton/MUIButton";
import MUICard from "./../../../Component/UI/MUICard/MUICard";
import { sanitizeObject } from "./../../../utils/helpers";
import classes from "./History.module.css";
import HistoryItem from "./HistoryItem";
import LoadingSkeleton from "./LoadingSkeleton";
import useHistory from "./useHistory";
import RefreshIcon from '@mui/icons-material/Refresh';

function hasData(obj, type) {
  const baseExpectedTypes = {
    name: "string",
    llm: "string",
    type: "string",
    competitors: "object",
    brand_scores: "object",
    category_dimensions: "object",
  };

  let expectedTypes = { ...baseExpectedTypes };

  if (type === "brand") {
    expectedTypes.core_attributes = "object";
    // expectedTypes.top_products = "object";
    expectedTypes.brand_description = "string";
    expectedTypes.brand_snippets = "object";
    expectedTypes.brand_themes = "object";
    expectedTypes.entity = "string";
    expectedTypes.positive_negative_attributes = "object";
    // expectedTypes.sources=  "object";
  } else if (type === "product") {
    expectedTypes.taxonomies = "object";
    expectedTypes.brand_description = "string";
    expectedTypes.brand_snippets = "object";
    expectedTypes.brand_themes = "object";
    expectedTypes.entity = "string";
    expectedTypes.positive_negative_attributes = "object";
    // expectedTypes.sources=  "object";
  } else if (type === "category") {
    expectedTypes.taxonomies = "object";
  }

  for (const key in expectedTypes) {
    if (expectedTypes.hasOwnProperty(key)) {
      const expectedType = expectedTypes[key];
      const actualValue = obj[key];

      // Check if the property exists in the object
      if (!(key in obj)) {
        return false;
      }

      const actualType = Array.isArray(actualValue)
        ? "object"
        : typeof actualValue;

      if (actualType !== expectedType) {
        return false;
      }

      if (expectedType === "object" && Array.isArray(actualValue)) {
        if (
          actualValue.length === 0 &&
          key !== "category_dimensions" &&
          key !== "core_attributes" &&
          key !== "positive_negative_attributes" &&
          key !== "brand_themes"
        ) {
          return false;
        }
        if (key === "brand_scores") {
          if (
            type === "category"
              ? actualValue.length === 0
              : actualValue.length !== 4 ||
              actualValue.some(
                (item) =>
                  item === null ||
                  item === undefined ||
                  !item.hasOwnProperty("total") ||
                  item.hasOwnProperty("error")
              )
          ) {
            return false;
          }
        }
      } else if (expectedType === "object" && !Array.isArray(actualValue)) {
        // Check if the object is empty for specific keys
        if (
          (key === "category_dimensions" ||
            key === "core_attributes" ||
            key === "positive_negative_attributes" ||
            key === "brand_themes") &&
          Object.keys(actualValue).length === 0
        ) {
          return false;
        }
      } else if (expectedType === "string" && actualValue.trim() === "") {
        return false;
      }
    }
  }
  return true;
}
const PAGE_LIMIT = 5;

export default function History({ filter = "brand", setCancelTransaction=()=>{},startPolling=()=>{} }) {
  const [filterOption, setFilterOption] = useState(filter);
  const discoveryCtx = useContext(DiscoveryContext);
  const {
    history,
    setHistory,
    loading,
    getHistory,
    hasReachedEnd,
    deleteHistory,
    error,
    setHasReachedEnd,
    page,
    setPage
  } = useHistory(filterOption);
  const state = discoveryCtx.state;
  useEffect(() => {
    setFilterOption(filter);
    setPage(1);
  }, [filter]);

  useEffect(() => {
    getHistory(page, PAGE_LIMIT);
  }, [page, filterOption]);

  useEffect(() => {
    const history = discoveryCtx?.state?.transactionHistory;
    if (Array.isArray(history)) {
      if (history.length === 0) {
        setHistory([]);
      } else {
        setHistory(history);
      }
    }
  }, [discoveryCtx.state?.transactionHistory]);

  function deleteHistoryItemHandler(id) {
    discoveryCtx.resetState();
    deleteHistory(id);
    // if (history.length === 1) {
    //   setPage(page => page + 1);
    // }
  }

  const refreshHistory = () => {
    setHistory([]);
    getHistory(1, PAGE_LIMIT);
    setHasReachedEnd(false);
    setPage(1);
  }
  


  useEffect(() => {
    const type = state.type ?? "brand";
    if (hasData(state, type)) {
      if (!state.id && type !== "category") {
        console.log("All Record Completed", state);
        discoveryCtx.updateLoading(false);
      }
    } else {
      if (state.id) {
        discoveryCtx.updateLoading(false);
      } else if (state.is_launched) {
        discoveryCtx.updateLoading(true);
      }
    }
  }, [hasData(state, state.type)]);


  return (
    <MUICard variant="elevated" elevation={0} className={classes.card}>
      <div className={classes.header}>
        <span className={classes.title}>History</span>
        <button
          onClick={() => refreshHistory()}
          className={classes.refreshBtn}
          title="Refresh"
        >
          <RefreshIcon fontSize="small" />
        </button>

      </div>
      {history.length > 0 && (
        <div className={classes.container}>
          {history.map((historyItem) => (
            <HistoryItem
              key={historyItem.transactionId}
              item={historyItem}
              onDelete={deleteHistoryItemHandler}
              setCancelTransaction={setCancelTransaction}
              startPolling={startPolling}
            />
          ))}
          <div className={classes.load_more}>
            {error && history.length > 0 && (
              <div className={classes.error_message}>
                <ErrorMessage message={error} />
              </div>
            )}
            {!loading && !hasReachedEnd && !discoveryCtx.loading && (
              <MUIButton
                className={classes.load_btn}
                variant="text"
                onClick={() => setPage((page) => page + 1)}
              >
                Load More
              </MUIButton>
            )}
            {loading && <CircularProgress size={22} />}
          </div>
        </div>
      )}
      {loading && history.length === 0 && <LoadingSkeleton />}
      {!loading && !error && history.length === 0 && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "70%" }}
        >
          <EmptyView message={"Nothing here."} />
        </div>
      )}
      {error && history.length === 0 && (
        <div className={classes.error}>
          <ErrorView title="Error" message={error} />
        </div>
      )}
    </MUICard>
  );
}
